<mat-form-field [formGroup]="matFormFieldGroup">
  <input
    placeholder="{{ config.placeholder }}"
    type="text"
    matInput
    (focus)="onFocus($event)"
    (keyPress)="onKeyboardEvent($event)"
    (keydown)="onKeyboardEvent($event)"
    (keyup)="onKeyboardEvent($event)"
    formControlName="autocomplete"
    [matAutocomplete]="auto"
  />
  <mat-hint *ngIf="config.hint">{{ config.hint }}</mat-hint>
  <mat-error *ngFor="let error of errors$ | async">{{ error }}</mat-error>
</mat-form-field>
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="optionDisplayFn"
  (optionSelected)="onOptionSelected($event)"
>
  <mat-option
    *ngFor="let option of options$ | async"
    [value]="option"
    [disabled]="disableFn(option)"
  >
    {{ config.optionDisplayFn(option) }}
  </mat-option>
</mat-autocomplete>
